/* eslint-disable react/prop-types */
import React from 'react';

import AmChart from './amchart.jsx';

import 'amcharts3/amcharts/serial';
import reportErrors from 'components/charts/reportErrors.jsx';

let StackedBarChart = ({
  data,
  balloonTexts = null,
  titleField = 'name',
  valueFields = ['value'],
  valueTitles = ['Value'],
  verticalAxisTitle = '',
  colors = ['#85ECFF', '#52b9e9'],
  fixedColumnWidth = undefined,
  horizontalAxisTitle = '',
  horizontalLabelRotation = 30,
}) =>
  <AmChart config={{
    type: 'serial',
    theme: 'light',
    zoomOutButtonImage: '',
    dataProvider: data,
    colors: colors,
    categoryField: titleField,
    categoryAxis: {
      labelRotation: horizontalLabelRotation,
      title: horizontalAxisTitle,
    },
    graphs: valueFields.map((valueField, i) => {
      return {
        type: 'column',
        valueField: valueField,
        fixedColumnWidth: fixedColumnWidth,
        fillAlphas: 1,
        lineAlpha: 0,
        balloonText: balloonTexts !== null && balloonTexts.length === valueFields.length ?
          `<span style='font-size:14px'>${balloonTexts[i]}</span>` :
          `<span style='font-size:14px'>${valueTitles[i]}:<b>[[value]]</b></span>`,
      };
    }),
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false,
    },
    valueAxes: [
      {
        stackType: 'regular',
        axisAlpha: 0,
        position: 'left',
        title: verticalAxisTitle,
      },
    ],
    startDuration: 0,
  }} />

;

export default reportErrors(StackedBarChart);
